import { render, staticRenderFns } from "./BZProject.vue?vue&type=template&id=2bd0bd80&scoped=true"
import script from "./BZProject.vue?vue&type=script&lang=js"
export * from "./BZProject.vue?vue&type=script&lang=js"
import style0 from "./BZProject.vue?vue&type=style&index=0&id=2bd0bd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0bd80",
  null
  
)

export default component.exports